import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserPagesRoutingModule} from "./user-pages-routing.module";
import {UserDetailModule} from "./user-detail/user-detail.module";
import {UserRewardModule} from "./user-reward/user-reward.module";
import {UserSurveyModule} from "@pages/user/user-survey/user-survey.module";
import {UserDashboardModule} from "@pages/user/user-dashboard/user-dashboard.module";


@NgModule({
  imports: [
    CommonModule,
    UserDashboardModule,
    UserRewardModule,
    UserDetailModule,
    UserSurveyModule,
    UserPagesRoutingModule,
  ],
  providers: []
})
export class UserPagesModule { }
